import request from "./request";
// import axios from "axios";
// let baseURL = "";
// const NODE_ENV = process.env.NODE_ENV;
// if (NODE_ENV === "development") {
//   baseURL = "";
// }
// axios.defaults.baseURL = baseURL;

export const getVerifyCodeFetch = () => request("/verify/verifyCode", null, "GET_IMAGE");
// export const getVerifyCodeFetch = () => request("/HiveQuery/ip/test", { ip: "17.0.190.185" }, "GET");
export const getUserInfoFetch = (param) => request("/login", param, "POST");

export const getProductTableListFetch = (param) => request("/pro/getPros", param, "POST_JSON");
export const getProductAfidListFetch = () =>
  request(
    "/pro/getPros",
    {
      offset: 0,
      limit: 99999,
    },
    "POST_JSON"
  );

export const deleteUserTableItemFetch = (param) => request("/pro/delprobyid", param, "POST");

export const updateProductTableItemFetch = (param) =>
  request("/pro/modifyPro", param, "POST_JSON");

export const addProductTableItemFetch = (param) => request("/pro/newlyPro", param, "POST_JSON");

export const getCountryListFetch = (param) => request("/pro/countrys", param, "POST");

export const getpurByCountryFetch = (param) => request("/pro/getpur", param, "POST");

export const getExtenSionListFetch = (param) => request("/pro/popre", param, "POST");

export const sendFileFetch = (param) => request("/file/uploadExcel", param, "POST", true);

export const getIncomeListFetch = (param) => request("/pro/income", param, "POST");

export const getmediaSourceFetch = (param) => request("/pro/getMedias", param, "POST");
// 新
export const getMediaSourceList = (param) => request("/mediaSource/list", param, "GET");


export const getSummaryListFetch = (param) => request("/pro/collect", param, "POST");
export const get180Ltv = (param) => request("/pro/get180Ltv", param, "POST");

export const getAllReportListFetch = (param) => request("/pro/allreport", param, "POST");

export const getCampaignList = (param) => request("/pro/campaignList", param, "GET");

export const addNewUserFetch = (param) => request("/usermgnt/addUser", param, "GET");
export const editUserFetch = (param) => request("/usermgnt/editUser", param, "GET");
export const getRoleUserListFetch = (param) =>
  request("/usermgnt/getUserInfoByPage", param, "GET");

export const modifyPassword = (param) => request("/modPass", param, "POST");
export const logoutFetch = () => request("/mgnt/logout", null, "GET");
export const getAlluserRole = () => request("/rolemgnt/getAllRoles", null, "GET");
export const getAllPermRole = () => request("/permmgnt/getAllPerms", null, "GET");
export const modifyUserManageFetch = (param) =>
  request("/userrole/addUserRoles", param, "GET");
export const modifyPermsManageFetch = (param) =>
  request("/userperm/addUserPerms", param, "GET");
export const addroleManageFetch = (param) => request("/rolemgnt/addRole", param, "GET");
export const getRoleInfoListFetch = (param) =>
  request("/rolemgnt/getRoleInfoByPage2", param, "GET");
export const modifyPermsRoleFetch = (param) =>
  request("/roleperm/addRolePerms", param, "GET");
export const editPermsRoleFetch = (param) => request("/rolemgnt/newEditRole", param, "GET");
export const getAllUserExpAdminFetch = (param) =>
  request("/uapp/getAllPlatmMember", param, "GET");
export const getAppBypageFetch = (param) => request("/uapp/getPermAppByPage", param, "POST");
export const changeALlPermFetch = (param) => request("/uapp/changeAllPerm", param, "POST");
export const changePermFetch = (param) => request("/uapp/changePerm", param, "POST");
export const delUserFetch = (param) => request("/usermgnt/delUser", param, "POST");
export const delRoleFetch = (param) => request("/rolemgnt/delRole", param, "POST");

//参数设置
export const getParamSettingListFetch = () => request("/sysPara/allSysPara", null, "GET");
export const modifyParamFetch = (param) => request("/sysPara/modifySysPara", param, "POST");
export const insertSysPara = (param) => request("/sysPara/insertSysPara", param, "POST");
export const addPlatformConfig = (param) => request("/platformConfig/add", param, "POST_JSON");
export const deletePlatformConfig = (param) => request("/platformConfig/delete", param, "POST");
export const getPlatformConfigList = (param) => request("/platformConfig/list", param, "POST_JSON");
export const updatePlatformConfig = (param) => request("/platformConfig/update", param, "POST_JSON");
export const getConfiguredPlatformProductList = (param) =>
  request("/platformConfig/configuredProducts", param, "GET").then((res) => ({
    ...res,
    products: Array.isArray(res.data) ? res.data : [],
  }));

export const showCountryFetch = (param) => request("/uapp/showCountry", param, "POST");
export const getPopuInfoFetch = (param) => request("/huawei/getPopuInfo", param, "POST");
export const getAppListFetch = (param) => request("/huawei/getAppList", param, "POST");
export const getPopuFetch = (data) => request("/monthReport/getPopu", data, "GET");
export const getalldimensiondataFetch = (data) =>
  request("/pro/getAllDimensionData", data, "POST");
export const getadddimensiondataFetch = (data) =>
  request("/pro/dimensionReport", data, "POST_JSON");
export const getPredictDataFetch = (data) => request("/pro/getPredictData", data, "POST");
export const getWarnRecordList = (param) =>
  request("/reportWarn/warnRecordList", param, "GET");
export const updateWarnRecord = (data) => request("/reportWarn/updateRecord", data, "POST");
export const getWarnRuleList = (param) => request("/reportWarn/ruleList", param, "GET");
export const bindWarnEmail = (data) => request("/reportWarn/bindEmail", data, "POST");
export const unbindWarnEmail = (data) => request("/reportWarn/unBindEmail", data, "POST");

//afid 补全 dbtid
export const getDbtIdByAfIdFetch = (data) => request("/product/getProductInfoByAfId", data, "GET");

export const ssologinFetch = () => request("/getActiveUser", null, "LOGIN"); //单点登录
export const setFrontUrlFetch = (param) => request("/setFrontUrl", param, "LOGIN");
export const ssologoutFetch = (param) => request("/logout", param, "LOGIN"); //单点登出

export const getOriginCountryListFetch = () => request("/pro/countrys", null, "POST");
// LT预测报表
// lt预测表数据查询
export const getItPrediction = (param) => request("/bi/ltPrediction", param, "POST_JSON");
// 检验记录
export const getViditionData = (param) => request("/bi/viditionData", param, "GET");
// lt预测表数据录入
export const inputPredictData = (data) => request("/bi/inputPredictData", data, "POST_JSON");
// 文件上传
export const uploadNewFiles = (data) => request("/youtube/newFiles", data, "POST", true);
// 获取创建人员
export const getOperatorList = (data) => request("/common/nameInfo", data, "GET");
// 获取指定部门人员列表
export const getUserInfoList = (data) => request("/common/orgUserInfo", data, "GET");
// 获取所有账号
export const getAllAdvertiserInfo = (data) => request("/bi/allAdvertiserInfo", data, "GET"); //获取
// 产品列表(通用)
export const getCommonProductList = (data) => request("/adCommon/product/list", data, "GET");
// 获取归因产品下拉列表
export const getConvertProductList = (data) =>
  request("/convert/getConvertProducts", data, "GET");
// 主体管理
// 添加投放主体
export const addDeliverySub = (data) => request("/deliverySub/add", data, "POST_JSON");
// 删除投放主体
export const deleteDeliverySub = (data) => request("/deliverySub/delete", data, "GET");
// 投放主体列表
export const getDeliverySubList = (data) => request("/deliverySub/list", data, "GET");
// 修改投放主体
export const updateDeliverySub = (data) => request("/deliverySub/update", data, "POST_JSON");

// 项目负责人列表
export const principalUserList = (data) => request("/common/principalUserList", data, "GET");
// 项目组列表
export const groupList = (data) => request("/common/groupList", data, "GET");
// 小组列表
export const squadList = (data) => request("/common/squadList", data, "GET");

// roi预测
export const getRoiPredictTable = (data) => request("/roi/predict", data, "POST_JSON");
// roi预测产品列表接口
export const getRoiProductList = () => request("/roi/getProducts", null, "GET");


// 产品权限分配—同步至批投
export const productSyncBatchLaunch = (data) => request("/uapp/synUserProductPerm", data, "POST_JSON");
// 查询已有域名组接口
export const getAccountGroupCodeList = () => request("/product/getAllAccountGroupCodes", null, "GET");
